import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MaterialModule } from '@material/material.module';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AddProspectEffects } from '@shared/add-prospect/store/add-prospect.effects';
import { addProspectReducer } from '@shared/add-prospect/store/add-prospect.reducer';
import { MojoAutocompleteModule } from 'mojo-autocomplete';
import { AddProspectModalComponent } from './components/add-prospect-modal/add-prospect-modal.component';

@NgModule({
  declarations: [AddProspectModalComponent],
  imports: [
    CommonModule,
    MojoAutocompleteModule,
    ReactiveFormsModule,
    MatDividerModule,
    MatDialogModule,
    StoreModule.forFeature('addProspect', addProspectReducer),
    EffectsModule.forFeature([AddProspectEffects]),
    MatIconModule,
    MaterialModule,
  ],
})
export class AddProspectModule {}
